import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FiCheck,
  FiClock,
  FiFileText,
  FiMail,
  FiMapPin,
  FiNavigation,
  FiPhone,
  FiSend,
  FiUpload,
  FiStar,
  FiMessageCircle,
  FiChevronRight,
  FiMenu,
  FiX,
} from "react-icons/fi";
import { useSubmitContactFormMutation } from "../services/api";
import logo from "../assets/melona logo.png";

const initialForm = {
  name: "",
  email: "",
  phone: "",
  service: "",
  deadline: "",
  message: "",
};

const SERVICES = [
  "Business Cards", "Flyers & Leaflets", "Banners & Signage",
  "Stickers & Labels", "Brochures", "Custom Packaging",
  "Design Support", "Digital Marketing", "Advertising", "Other",
];

const CONTACT = {
  phoneOne: "0956565636",
  phoneTwo: "0956565646",
  email: "melona5656@gmail.com",
  address: "Debre Birhan, Atse Zeryakob Square, Kaleab Building, Ground Floor",
  mapQuery: "Melona Printing Debre Birhan Atse Zeryakob Square Kaleab Building",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15666.036363636364!2d39.53194444444444!3d9.680555555555555!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwNDAnNTAuMCJOIDM5wrAzMSc1NS4wIkU!5e0!3m2!1sen!2set!4v1",
  whatsapp: "251956565636",
};

const ContactPage = () => {
  const [form, setForm] = useState(initialForm);
  const [sent, setSent] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [submitContactForm, { isLoading, error }] = useSubmitContactFormMutation();
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(CONTACT.mapQuery)}`;

  useEffect(() => {
    document.title = "Contact Us - Melona Printing";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitContactForm(form).unwrap();
      setSent(true);
      setForm(initialForm);
    } catch (err) {
      console.error("Failed to submit contact form:", err);
    }
  };

  const resetForm = () => { setSent(false); setForm(initialForm); };

  return (
    <div className="melona-premium">
      {/* ── Navigation ── */}
      <nav className="melona-nav scrolled">
        <div className="melona-nav__inner">
          <Link to="/" className="melona-nav__logo">
            <img src={logo} alt="Melona" style={{ height: "40px" }} />
          </Link>
          <div className="melona-nav__links">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/#portfolio">Portfolio</Link>
            <Link to="/contact" className="active">Contact</Link>
            <Link to="/login">Login</Link>
          </div>
          <Link to="/contact" className="melona-nav__cta">
            <FiPhone /> Get Quote
          </Link>
          <button className="melona-nav__toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
            {mobileMenuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
        
        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="melona-mobile-menu">
            <nav>
              <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
              <Link to="/about" onClick={() => setMobileMenuOpen(false)}>About</Link>
              <Link to="/services" onClick={() => setMobileMenuOpen(false)}>Services</Link>
              <Link to="/gallery" onClick={() => setMobileMenuOpen(false)}>Portfolio</Link>
              <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="active">Contact</Link>
              <Link to="/login" onClick={() => setMobileMenuOpen(false)}>Login</Link>
            </nav>
            <Link to="/contact" className="melona-btn melona-btn--primary melona-btn--full" style={{ marginTop: "var(--sp-4)" }} onClick={() => setMobileMenuOpen(false)}>
              <FiPhone /> Get Free Quote
            </Link>
          </div>
        )}
      </nav>

      {/* ── Hero ── */}
      <section className="melona-contact-hero">
        <div className="melona-container melona-contact-hero__content">
          <span className="melona-eyebrow"><FiPhone /> Contact Us</span>
          <h1 className="melona-contact-hero__title">
            Send the print specs.<br />
            <span className="melona-contact-hero__title-accent">We will help with the next step.</span>
          </h1>
          <p className="melona-contact-hero__subtitle">
            Call, visit, or send a quote request with your quantity, material,
            artwork status, and deadline.
          </p>
          <div className="melona-contact-hero__quick">
            <a href={`tel:${CONTACT.phoneOne}`} className="melona-contact-hero__quick-item">
              <FiPhone /> {CONTACT.phoneOne}
            </a>
            <a href={`tel:${CONTACT.phoneTwo}`} className="melona-contact-hero__quick-item">
              <FiPhone /> {CONTACT.phoneTwo}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="melona-contact-hero__quick-item">
              <FiMail /> {CONTACT.email}
            </a>
          </div>
        </div>
      </section>

      {/* ── Main Contact Layout ── */}
      <section className="melona-section">
        <div className="melona-container">
          <div className="melona-contact-layout">
            {/* Left: Info */}
            <div className="melona-contact-info-panel">
              <div className="melona-section-header" style={{ textAlign: "left", marginBottom: "var(--sp-6)" }}>
                <span className="melona-eyebrow"><FiMapPin /> Visit or Call</span>
                <h2 className="melona-section-title" style={{ fontSize: "1.75rem" }}>Melona Printing</h2>
                <p className="melona-section-subtitle">
                  Bring a sample, discuss materials, collect finished work, or confirm a deadline in person.
                </p>
              </div>
              <div className="melona-contact-details">
                <div className="melona-contact-detail-item">
                  <div className="melona-contact-detail-item__icon"><FiPhone /></div>
                  <div>
                    <h4>Phone</h4>
                    <p>{CONTACT.phoneOne} / {CONTACT.phoneTwo}</p>
                  </div>
                </div>
                <div className="melona-contact-detail-item">
                  <div className="melona-contact-detail-item__icon"><FiMail /></div>
                  <div>
                    <h4>Email</h4>
                    <p>{CONTACT.email}</p>
                  </div>
                </div>
                <div className="melona-contact-detail-item">
                  <div className="melona-contact-detail-item__icon"><FiClock /></div>
                  <div>
                    <h4>Business Hours</h4>
                    <p>Monday to Saturday, 8:00 AM – 6:00 PM</p>
                  </div>
                </div>
                <div className="melona-contact-detail-item">
                  <div className="melona-contact-detail-item__icon"><FiMapPin /></div>
                  <div>
                    <h4>Location</h4>
                    <p>{CONTACT.address}</p>
                  </div>
                </div>
              </div>
              <div className="melona-contact-actions">
                <a href={mapsUrl} target="_blank" rel="noreferrer" className="melona-btn melona-btn--outline">
                  Open in Google Maps <FiNavigation />
                </a>
                <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="melona-btn melona-btn--gold">
                  <FiMessageCircle /> WhatsApp Us
                </a>
              </div>
            </div>

            {/* Right: Contact Form */}
            <div className="melona-contact-form-panel">
              {sent ? (
                <div className="melona-contact-success">
                  <div className="melona-contact-success__icon"><FiCheck /></div>
                  <h3>Message Sent Successfully!</h3>
                  <p>
                    Thank you for reaching out to Melona Printing. We have received your quote request
                    and will get back to you soon to confirm artwork, quantity, material, and deadline.
                  </p>
                  <button className="melona-btn melona-btn--outline" type="button" onClick={resetForm}>
                    Send Another Message <FiChevronRight />
                  </button>
                </div>
              ) : (
                <>
                  {error && (
                    <div className="melona-error-banner">
                      <FiPhone />
                      <div>
                        <strong>Failed to send message</strong>
                        <p>{error?.data?.message || "Please try again or contact us directly by phone."}</p>
                      </div>
                    </div>
                  )}
                  <div className="melona-contact-form-header">
                    <div className="melona-contact-form-header__icon"><FiFileText /></div>
                    <div>
                      <h2>Request a Quote</h2>
                      <p>Useful details help Melona price faster and avoid rework.</p>
                    </div>
                  </div>
                  <form className="melona-form" onSubmit={handleSubmit}>
                    <div className="melona-form-row">
                      <div className="melona-form-group">
                        <label>Your name <span className="required-star">*</span></label>
                        <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="e.g. Abebe Kebede" required />
                      </div>
                      <div className="melona-form-group">
                        <label>Email address <span className="required-star">*</span></label>
                        <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="your@email.com" required />
                      </div>
                    </div>
                    <div className="melona-form-row">
                      <div className="melona-form-group">
                        <label>Phone number</label>
                        <input type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="09xxxxxxxx" />
                      </div>
                      <div className="melona-form-group">
                        <label>Service needed</label>
                        <select value={form.service} onChange={(e) => setForm({ ...form, service: e.target.value })}>
                          <option value="">Select a service</option>
                          {SERVICES.map((s) => <option key={s} value={s}>{s}</option>)}
                        </select>
                      </div>
                    </div>
                    <div className="melona-form-group">
                      <label>Deadline or event date</label>
                      <input type="text" value={form.deadline} onChange={(e) => setForm({ ...form, deadline: e.target.value })} placeholder="e.g. Friday morning, June launch, flexible" />
                    </div>
                    <div className="melona-form-group">
                      <label>Project details <span className="required-star">*</span></label>
                      <textarea rows="5" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Quantity, size, material, finish, artwork status, pickup or delivery..." required />
                    </div>
                    <div className="melona-upload-note">
                      <FiUpload />
                      <span>Attach or bring print-ready artwork when Melona confirms the order.</span>
                    </div>
                    <button type="submit" className="melona-btn melona-btn--primary melona-btn--full" disabled={isLoading}>
                      <FiSend /> {isLoading ? "Sending..." : "Send Request"}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>

          {/* ── Large Map Section ── */}
          <div style={{ marginTop: "4rem" }}>
            <div className="melona-section-header" style={{ textAlign: "center", marginBottom: "2rem" }}>
              <span className="melona-eyebrow"><FiMapPin /> Find Us</span>
              <h2 className="melona-section-title">Visit Our Location</h2>
              <p className="melona-section-subtitle" style={{ maxWidth: "600px", margin: "0 auto" }}>
                Located at Atse Zeryakob Square, Kaleab Building, Ground Floor in Debre Birhan
              </p>
            </div>
            <div className="melona-large-map">
              <iframe
                src={CONTACT.mapEmbed}
                width="100%"
                height="600"
                style={{ 
                  border: 0, 
                  borderRadius: "16px",
                  boxShadow: "0 20px 60px rgba(0, 0, 0, 0.1)"
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Melona Printing Location"
              />
            </div>
            <div style={{
              marginTop: "2rem",
              padding: "1.5rem",
              background: "linear-gradient(135deg, #0F5D4F 0%, #22A06B 100%)",
              borderRadius: "12px",
              color: "#fff",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "1rem",
              flexWrap: "wrap"
            }}>
              <FiMapPin size={24} />
              <div style={{ flex: "1", minWidth: "250px" }}>
                <h4 style={{ margin: "0 0 0.5rem 0", fontSize: "1.125rem", fontWeight: "700" }}>
                  Debre Birhan, Atse Zeryakob Square
                </h4>
                <p style={{ margin: "0", opacity: "0.95", fontSize: "0.9375rem" }}>
                  Kaleab Building, Ground Floor
                </p>
              </div>
              <a 
                href={mapsUrl} 
                target="_blank" 
                rel="noreferrer" 
                style={{
                  padding: "0.875rem 1.75rem",
                  background: "#fff",
                  color: "#0F5D4F",
                  borderRadius: "8px",
                  fontWeight: "600",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
                }}
              >
                <FiNavigation /> Get Directions
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
  
    </div>
  );
};

export default ContactPage;